export function getTracker() {
  return window.uetq || [];
}

export function trackPageview() {
  try {
    getTracker().push('pageLoad');
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e);
  }
}

export function trackEvent(
  eventAction = '',
  eventRevenueValue = '',
  eventCurrency = '',
) {
  try {
    getTracker().push('event', eventAction, {
      revenue_value: eventRevenueValue,
      currency: eventCurrency,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e);
  }
}

export function initialize(newTrackerId) {
  try {
    /* eslint-disable */
        (function (w, d, t, r, u) {
            var f, n, i;
            (w[u] = w[u] || []),
                (f = function () {
                    var o = { ti: newTrackerId };
                    (o.q = w[u]), (w[u] = new UET(o)), w[u].push('pageLoad');
                }),
                (n = d.createElement(t)),
                (n.src = r),
                (n.async = 1),
                (n.onload = n.onreadystatechange = function () {
                    var s = this.readyState;
                    (s && s !== 'loaded' && s !== 'complete') ||
                        (f(), (n.onload = n.onreadystatechange = null));
                }),
                (i = d.getElementsByTagName(t)[0]),
                i.parentNode.insertBefore(n, i);
        })(window, document, 'script', '//bat.bing.com/bat.js', 'uetq');
        /* eslint-enable */
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(e);
  }
}

export default {
  initialize,
  getTracker,
  trackPageview,
  trackEvent,
};
